import { PATHS } from '@/routes/PATHS'
import { CoreLevelFeatureNames } from '@/services/types/permissions/permissionFeatures/mockCorePermissionFeature'
import { useCorePermissions } from '@/stores/permissions/permissions'
import { ThunderboltOutlined, UsergroupAddOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

export function useSettingsSidebarItems() {
  const { t } = useTranslation()
  const userManagementPermission = useCorePermissions(CoreLevelFeatureNames.userManagement)
  const hasUserManagementPermission = !!userManagementPermission?.edit

  const allItems = [
    {
      key: PATHS.accountConnectionsPage,
      icon: <ThunderboltOutlined />,
      label: t('sidebarItems.connections'),
    },
    {
      key: PATHS.userManagementPage,
      icon: <UsergroupAddOutlined />,
      label: t('sidebarItems.userManagement'),
    },
  ]

  return allItems.filter((item) =>
    hasUserManagementPermission ? true : item.key !== PATHS.userManagementPage,
  )
}
